module Factive.Core {
    "use strict"
    
    export class StorageManager {
        private _allowLocalStorage: boolean;
        private _gameID: string;

        constructor() { 			"use strict";
            this._allowLocalStorage = true;
            this._gameID = "";
        };

        // ========================= Initialization =========================
        public initialize(gameID) {
            this._gameID = gameID;
        };

        // ========================= Loading =========================
        public loadData(key) {
            key = this._gameID + key;
            if (this._allowLocalStorage) {
                try {
                    var data = localStorage.getItem(key);
                    if (data) { return JSON.parse(data); }
                }
                catch(error) {
                    //console.log("StorageManager.loadData("+key+")", error.message);
                    this._allowLocalStorage = false;
                }
            }
            return null;
        };

        // ========================= Saving =========================
        public saveData(key, value) {
            key = this._gameID + key;
            value = JSON.stringify(value);

            if (this._allowLocalStorage) {
                try {
                    localStorage.setItem(key, value);
                    return true; // Progress was successfully saved!
                }
                catch(error) {
                    //console.log("StorageManager.saveData("+key+")", error.message);
                    this._allowLocalStorage = false;
                    return false; // Saving failed!
                }
            }
        };
    }
}


// WEBPACK FOOTER //
// src/typescript/Core/Storage/StorageManager.ts